import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "../../../../../../hooks/useTranslation";
import LoadingButton from "@mui/lab/LoadingButton";

type UndercutWarningDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
};

export const UndercutWarningDialog = ({
  open,
  onClose,
  onSave,
  isLoading,
}: UndercutWarningDialogProps) => {
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.stores.competitionSettings.competitionSettings.undercutWarningDialog",
  );

  return (
    <Dialog
      open={open}
      onClose={!isLoading ? onClose : undefined}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{translate("title")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {translate("description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={!isLoading ? onClose : undefined} disabled={isLoading}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>
        <LoadingButton onClick={onSave} autoFocus loading={isLoading}>
          {translate("saveAnyway")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
